"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Yup = require("yup");
var DebtorValidator = function (_a) {
    var context = _a.context;
    return Yup.object().shape({
        email: Yup.string().trim().email().nullable().max(50, 'Email cannot be more than 50 characters'),
        address_1: Yup.string()
            .trim()
            .max(100, 'Address Line 1 cannot be more than 100 characters')
            .nullable()
            .required('Address Line 1 is a required field'),
        address_2: Yup.string().trim().max(100, 'Address Line 2 cannot be more than 100 characters').nullable(),
        city: Yup.string()
            .trim()
            .max(20, 'City cannot be more than 20 characters')
            .nullable()
            .required('City is a required field'),
        post_code: Yup.string()
            .trim()
            .required('Postcode is a required field')
            .max(8, 'Postcode cannot exceed 8 characters')
            .nullable()
            .matches(/[A-Za-z][A-Ha-hK-Yk-y]?[0-9][A-Za-z0-9]? [0-9][A-Za-z]{2}|[Gg][Ii][Rr] 0[Aa]{2}/, 'Invalid Postcode Format'),
        protocol_id: Yup.number().required('Required'),
        merge_variables: Yup.object({
            representative_name: Yup.string().when('$protocol_id', {
                is: 2,
                then: Yup.string().required('Representative Name is a required field'),
                otherwise: Yup.string().notRequired(),
            }),
        }),
        trading_name: Yup.string().trim().max(100, 'Trading name cannot be more than 100 characters').nullable(),
        companies_house_number: Yup.string()
            .trim()
            .max(20, 'Companies house number can not be more than 20 characters')
            .nullable(),
        first_name: Yup.string()
            .trim()
            .max(100, 'First name cannot be longer than 100 characters')
            .nullable()
            .test('Name', 'When the debtor is an individual, you must provide their first name.', function (value) {
            var protocol_id = this.parent.protocol_id;
            if (protocol_id === 1) {
                return value != null && value.trim() !== '';
            }
            return true;
        }),
        middle_name: Yup.string().trim().max(100, 'Name cannot be longer than 100 characters').nullable(),
        last_name: Yup.string()
            .trim()
            .max(100, 'Name cannot be longer than 100 characters')
            .nullable()
            .test('Name', 'When the debtor is an individual, you must provide their surname.', function (value) {
            var protocol_id = this.parent.protocol_id;
            if (protocol_id === 1) {
                return value != null && value.trim() !== '';
            }
            return true;
        }),
        company_name: Yup.string()
            .trim()
            .max(100, 'Company name cannot be longer than 100 characters')
            .nullable()
            .test('Name', 'When the debtor is a business, the company name must be entered', function (value) {
            var protocol_id = this.parent.protocol_id;
            if (protocol_id === 2) {
                return value != null && value.trim() !== '';
            }
            return true;
        }),
    });
};
exports.default = DebtorValidator;
